import { Container, Row, Col, Button } from 'react-bootstrap';
import GenericCard from '../../../components/GenericCards/GenericCards';
import DefaultCard from '../../../components/DefaultCard';
import CostAndCoverageModal from '../../widgets/Cost&CoverageModal/Cost&CoverageModal';
import ReportEventModal from '../ReportEventModal/ReportEventModal';
import useModal from '../../../hooks/useModal';
import { useState } from 'react';

export type LifeEventData = {
  id: string;
  title: string;
  imagePath: string;
};

export type LifeEventCongratulationsProps = React.PropsWithChildren<{
  data: LifeEventData;
}>;

const LifeEventCongratulations = ({ data }: LifeEventCongratulationsProps) => {
  const [showcCostModal, handleShowCostModal, handleCloseCostModal] =
    useModal();
  const [showReportModal, handleShowReportModal, handleCloseReportModal] =
    useModal();

  const [reportEventValue, setReportEventValue] = useState(undefined);

  return (
    <Container className={'cnd-custom-container my-13 mb-lg-0'}>
      <Row className={'mb-12'}>
        <Col>
          <GenericCard
            className={'px-11 pb-11 pt-lg-11 pt-0'}
            variant={'white'}
            children={
              <Row className={'d-flex flex-row-reverse'}>
                <Col className={'col-lg-2 text-end text-lg-start'}>
                  <img
                    src={`${process.env.PUBLIC_URL}/${data.imagePath}`}
                    alt="baby"
                    className={'img-translate'}
                  />
                </Col>
                <Col className={'col-12 col-lg-10'}>
                  <h2 className={'text-sm-24-lg-32'}>Congratulations!</h2>
                  <span className={'text-fs-6 text-light-grey fw-light'}>
                    {data.title}
                  </span>
                </Col>
              </Row>
            }
          />
        </Col>
      </Row>
      <Row>
        <Col className={'col-12 col-lg-6 mb-7 mb-lg-0'}>
          <DefaultCard
            isCurrentEvent
            className={'h-100'}
            leftHeading={'Preview Cost & Coverage'}
            leftSubheading={'Easy way to see your costs and coverages'}
            variant={'transparent'}
            button={
              <Button
                className={'align-self-end'}
                size={'sm'}
                variant={'primary-outline'}
                onClick={handleShowCostModal}
              >
                Preview
              </Button>
            }
          />
        </Col>
        <Col className={'col-12 col-lg-6'}>
          <DefaultCard
            className={'h-100'}
            leftHeading={'Report Event'}
            leftSubheading={'Update your benefits'}
            variant={'blue-motif'}
            button={
              <Button
                onClick={handleShowReportModal}
                variant="primary-shadow"
                size="sm"
              >
                Proceed
              </Button>
            }
          />
        </Col>
      </Row>

      <CostAndCoverageModal
        showModal={showcCostModal}
        handleCloseModal={handleCloseCostModal}
      />

      <ReportEventModal
        showModal={showReportModal}
        onDateChange={setReportEventValue}
        value={reportEventValue}
        handleCloseModal={handleCloseReportModal}
      />
    </Container>
  );
};

export default LifeEventCongratulations;
